import styled from 'styled-components';
import { desktop1024, desktop1440 } from '@nubank/nuds-web/styles/breakpoints';

import Section from 'components/structure/Section';
import { paddingBuilder } from 'styles/themeUtils';

const SectionRoot = styled(Section)`
  ${paddingBuilder.all(3, 1.5)}

  & > * {
    flex-direction: column;
  }

  ${desktop1024`
    ${paddingBuilder.all(6, 3.5)}

    & > * {
      flex-flow: row nowrap;
    }
  `}

  ${desktop1440`
    ${paddingBuilder.all(8, 0)}

    & > * {
      ${paddingBuilder.all(0, 7)}
    }
  `}
`;

SectionRoot.displayName = 'SectionRoot';

export default SectionRoot;
